import React, { Component } from "react";
// import axios from "axios";
import "react-responsive-modal/styles.css";
import classnames from "classnames";
import { Modal } from "react-responsive-modal";
import Form from "react-bootstrap/Form";
import moment from "moment";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import {
  InputBoxComponent,
  TextAreaReusableComponent,
} from "../../inputReusableComponent/InputBoxComponent";
import IncrementDecrement from "../../incrementDecrement/IncrementDecrement";
import { SlidingComponent } from "../../slidingToggleComponent/SlidingComponent";
import { IconBoxReusableComponent } from "../../IconBoxReusable/IconBoxReusableComponent";
import { PopupActionButton } from "../../buttonReusableComponent/ButtonReusableComponent";
import { EditDetailsTop } from "./EditDetailsTop";
import { PopupIconButtonReusable } from "../allPopupReusableIconButton/PopupIconButtonReusable";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { vendor_dashboard_edit_action } from "../../../../store/actions/dashboardAction/addingAction";
import isEmpty from "../../../../store/validation/is-Empty";

export class EditReservation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actionButton: false,
      country_code: "",
      mobile_number: "",
      name: "",
      adult: 0,
      kids: 0,
      handicap: 0,
      highchair: 0,
      currentState: true,
      room_number: "",
      table_number: "",
      seating_preference: "",
      special_Ocassion: "",
      editDiner: {},
      editNumberName: {},
      allSeatingArea: [],
      reservationTime: "",
      day: "",
      months: "",
      year: "",
      hour: "",
      minute: "",
      date: "",
      time: "",
      errors: {},
      error: null,
      isLoading: false,
      hasSetEditProps: false,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      nextProps.onboarding._id &&
      !isEmpty(nextProps.onboarding.selected_seating_area) &&
      !isEmpty(nextProps.dataSend)
    ) {
      if (
        !isEmpty(nextProps.onboarding.selected_seating_area) &&
        !isEmpty(nextProps.dataSend) &&
        !nextState.hasSetEditProps
      ) {
        return {
          allSeatingArea: !isEmpty(nextProps.onboarding.selected_seating_area)
            ? nextProps.onboarding.selected_seating_area
            : "",
          editDiner: !isEmpty(nextProps.dataSend) ? nextProps.dataSend : "",
          editNumberName: !isEmpty(nextProps.dataSend)
            ? nextProps.dataSend.user_details
            : "",
          seating_preference: !isEmpty(nextProps.dataSend.seating_preference[0])
            ? nextProps.dataSend.seating_preference[0]
            : "",
          kids: !isEmpty(nextProps.dataSend.kids_count)
            ? nextProps.dataSend.kids_count
            : "",
          adult: !isEmpty(nextProps.dataSend.adult_count)
            ? nextProps.dataSend.adult_count
            : "",
          handicap: !isEmpty(nextProps.dataSend.handicap_chair)
            ? nextProps.dataSend.handicap_chair
            : "",
          highchair: !isEmpty(nextProps.dataSend.high_chair)
            ? nextProps.dataSend.high_chair
            : "",
          reservationTime: !isEmpty(nextProps.dataSend.reservationTime)
            ? moment(nextProps.dataSend.reservationTime).format(
                "YYYY-MM-DDTHH:mm"
              )
            : "",
          hasSetEditProps: true,
        };
      }
    }
    return null;
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };

  onCloseModal = () => {
    this.setState({ open: false });
  };

  /**************************
   * @DESC - Current and Saving HANDLER
   ***************************/
  toggleFunction = (e) => {
    this.setState({
      [e.target.name]: e.target.checked,
    });
  };

  /**************************
   * @DESC - ONCHANGE HANDLER
   ***************************/
  handleOnChange = (value) => {
    this.setState({ country_code: "+" + value });
  };

  handleDateChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      actionChange: true,
    });
  };

  onChangeTwo = (e) => {
    let editDiner = this.state.editNumberName;
    editDiner[e.target.name] = e.target.value;
    this.setState({
      editNumberName: editDiner,
      actionChange: true,
    });
  };

  onChange = (e) => {
    let editDiner = this.state.editDiner;
    editDiner[e.target.name] = e.target.value;
    this.setState({
      editDiner: editDiner,
      actionChange: true,
    });
  };

  IncrementKidsItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.kids < 100) {
        return {
          kids: prevState.kids + 1,
        };
      } else {
        return null;
      }
    });
  };
  IncrementAdultItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.adult < 100) {
        return {
          adult: prevState.adult + 1,
        };
      } else {
        return null;
      }
    });
  };
  IncrementhandicapItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.handicap < 100) {
        return {
          handicap: prevState.handicap + 1,
        };
      } else {
        return null;
      }
    });
  };
  IncrementhighchairItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.highchair < 100) {
        return {
          highchair: prevState.highchair + 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseKidsItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.kids > 0) {
        return {
          kids: prevState.kids - 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseAdultItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.adult > 0) {
        return {
          adult: prevState.adult - 1,
        };
      } else {
        return null;
      }
    });
  };

  DecreaseHandicapItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.handicap > 0) {
        return {
          handicap: prevState.handicap - 1,
        };
      } else {
        return null;
      }
    });
  };
  DecreaseHighchairItem = (e) => {
    e.preventDefault();
    this.setState((prevState) => {
      if (prevState.highchair > 0) {
        return {
          highchair: prevState.highchair - 1,
        };
      } else {
        return null;
      }
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };
  /***************************
   * @DESC on Button Handler
   ***************************/
  onButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      seating_preference: type,
    });
  };

  onSubmitHandler = (e) => {
    e.preventDefault();
    let editNumberName = this.state.editNumberName;
    let editDiner = this.state.editDiner;
    const token = this.props.auth.user.accessToken;
    const vendor_id = this.props.auth.user.VendorUser._id;
    const diner_id = editDiner._id;
    const formData = {
      user_details: {
        country_code: editNumberName.country_code,
        mobile_number: editNumberName.mobile_number,
        name: editNumberName.name,
      },
      adult_count: this.state.adult,
      kids_count: this.state.kids,
      handicap_chair: this.state.handicap,
      high_chair: this.state.highchair,
      room_number: editDiner.room_number,
      table_number: editDiner.table_number,
      seating_preference: this.state.seating_preference,
      occasion: editDiner.occasion,
      reservationTime: Date.parse(this.state.reservationTime),
    };
    this.props.vendor_dashboard_edit_action(
      formData,
      diner_id,
      vendor_id,
      token
    );
    this.onCloseModal();
  };

  render() {
    const {
      errors,
      seating_preference,
      open,
      editDiner,
      editNumberName,
      allSeatingArea,
    } = this.state;
    return (
      <div>
        {/* <PopupActionButton
          buttonText={this.props.buttonText}
          buttonType="button"
          buttonClass="cancel"
          onClick={this.onOpenModal}
        /> */}
        <PopupIconButtonReusable
          buttonClass={this.props.buttonClass}
          titleText="Edit Reservation"
          image={require("../../../../assets/images/ActionImages/newEdit.png")}
          onClick={this.onOpenModal}
        />
        <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "add-diner-main-popup",
            closeButton: "customCloseButton",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div className="top-box-header-editdinner">
            <h4>{this.props.bigText}</h4>
          </div>
          <div className="inside-edit-reservation-body">
            <Form noValidate onSubmit={this.onSubmitHandler}>
              <EditDetailsTop
                allPropsData={this.state.editDiner}
                allPropsDataTwo={this.state.editNumberName}
              />
              <Form.Row className="margin-top-section">
                <div className="col-12 edit-details-below">
                  <h3 className="mb-3">Edit Details Below</h3>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="row">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 pr-0">
                      {" "}
                      <Form.Group
                        className="reusableInputComponent-main mb-0"
                        controlId={"country_code"}
                      >
                        <div className="input-phone-country-code-reusable">
                          <select
                            name="country_code"
                            value={this.state.country_code}
                            onChange={this.onChangeTwo}
                          >
                            <option value={this.state.country_code}>
                              {editNumberName.country_code}
                            </option>
                            {getCountries().map((country) => (
                              <option
                                key={country}
                                value={"+" + getCountryCallingCode(country)}
                              >
                                {en[country]} (+{getCountryCallingCode(country)}
                                )
                              </option>
                            ))}
                          </select>
                        </div>
                      </Form.Group>
                    </div>
                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 pl-0">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="mobile_number"
                        labelText="Mobile Number"
                        inputType="number"
                        placeHolder="Enter mobile number"
                        name="mobile_number"
                        onChange={this.onChangeTwo}
                        value={editNumberName.mobile_number}
                        required="required"
                        showBottom={true}
                        error={errors.mobile_number}
                        inputClassName={classnames(
                          "input-component-inputfield",
                          {
                            invalid: errors.mobile_number,
                          }
                        )}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 offset-md-1 offset-lg-1 offset-xl-1 margin-top-section-custom">
                  <InputBoxComponent
                    displayLabel={false}
                    controlId="name"
                    inputType="text"
                    placeHolder="Enter Name"
                    name="name"
                    onChange={this.onChangeTwo}
                    value={editNumberName.name}
                    required="required"
                    showBottom={true}
                    error={errors.name}
                    inputClassName={classnames("input-component-inputfield", {
                      invalid: errors.name,
                    })}
                  />
                </div>
              </Form.Row>
              <Form.Row className="margin-top-section party-size-sliding">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <Form.Label className="col-12 p-0 party-size-label mb-3">
                    Party Size
                  </Form.Label>
                  <div className="row margin-top-section">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <IncrementDecrement
                        iconImage={require("../../../../assets/images/AuthImages/children.svg")}
                        title="Kids"
                        iconText="Kids"
                        decreaseItem={this.DecreaseKidsItem}
                        incrementItem={this.IncrementKidsItem}
                        name="kids"
                        onChange={this.onChange}
                        quantity={this.state.kids}
                      />
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                      <IncrementDecrement
                        iconImage={require("../../../../assets/images/AuthImages/employees.svg")}
                        title="Adult"
                        iconText="Adult"
                        decreaseItem={this.DecreaseAdultItem}
                        incrementItem={this.IncrementAdultItem}
                        onChange={this.onChange}
                        quantity={this.state.adult}
                        name="adult"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div className="col-12 p-0 d-flex justify-content-between">
                    <div>
                      <p className="sliding-label">
                        Need Handicap access or a Highchair?
                      </p>
                    </div>
                    <SlidingComponent
                      name="currentState"
                      currentState={
                        this.state.highchair === 0 && this.state.handicap === 0
                          ? false
                          : true
                      }
                      type={"checkbox"}
                      toggleclass={"toggle d-flex align-items-center mb-2"}
                      toggleinputclass={"toggle__switch"}
                      onChange={this.toggleFunction}
                      // slidingonClick={this.onSelecttogglestatusChange(data)}
                      defaultChecked={
                        this.state.highchair === 0 && this.state.handicap === 0
                          ? false
                          : true
                      }
                    />
                  </div>
                  <div className="row mt-4">
                    {this.state.highchair === 0 ? null : (
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <IncrementDecrement
                          iconImage={require("../../../../assets/images/AuthImages/wheelchair.svg")}
                          title="Handicap"
                          iconText="Handicap"
                          decreaseItem={this.DecreaseHandicapItem}
                          incrementItem={this.IncrementhandicapItem}
                          onChange={this.onChange}
                          quantity={this.state.handicap}
                          name="handicap_chair"
                        />
                      </div>
                    )}
                    {this.state.handicap === 0 ? null : (
                      <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                        <IncrementDecrement
                          iconImage={require("../../../../assets/images/AuthImages/highchair.svg")}
                          title="Highchair"
                          iconText="Highchair"
                          decreaseItem={this.DecreaseHighchairItem}
                          incrementItem={this.IncrementhighchairItem}
                          onChange={this.onChange}
                          quantity={this.state.highchair}
                          name="high_chair"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Form.Row>
              <Form.Row className="party-size-sliding reservation-time">
                <div className="col-12 mb-4">
                  <Form.Label className="party-size-label">
                    Reservation Date and Time
                  </Form.Label>
                </div>
                <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 d-flex align-items-center">
                  <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 p-sm-0">
                    <InputBoxComponent
                      displayLabel={false}
                      controlId="reservationTime"
                      labelText="Reservation Date Time"
                      inputType="datetime-local"
                      placeHolder="Enter Reservation Date Time"
                      name="reservationTime"
                      onChange={this.handleDateChange}
                      onFocusOut={this.onFocusOut}
                      value={this.state.reservationTime}
                      required="required"
                      showBottom={true}
                      error={errors.reservationTime}
                      inputClassName={classnames("input-component-inputfield", {
                        invalid: errors.reservationTime,
                      })}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 hour-section">
                  <div className="col-6 d-flex align-items-center small-device-width">
                    <Form.Label className="room-number-label">
                      Room No.
                    </Form.Label>
                    <div className="col-7 small-device-width-input">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="room_number"
                        inputType="number"
                        placeHolder="Room No."
                        maxLength="5"
                        name="room_number"
                        onChange={this.onChange}
                        value={editDiner.room_number}
                        required="required"
                        showBottom={true}
                        error={errors.room_number}
                        inputClassName={classnames(
                          "input-component-inputfield text-center",
                          {
                            invalid: errors.room_number,
                          }
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-6 d-flex align-items-center small-device-width">
                    <Form.Label className="room-number-label">
                      Table No.
                    </Form.Label>
                    <div className="col-7 small-device-width-input">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="table_number"
                        inputType="number"
                        placeHolder="Table No."
                        name="table_number"
                        maxLength="5"
                        onChange={this.onChange}
                        value={editDiner.table_number}
                        required="required"
                        showBottom={true}
                        error={errors.table_number}
                        inputClassName={classnames(
                          "input-component-inputfield text-center",
                          {
                            invalid: errors.table_number,
                          }
                        )}
                      />
                    </div>
                  </div>
                </div>
              </Form.Row>
              <Form.Row className="margin-top-section"></Form.Row>
              <Form.Row className="margin-top-section">
                <div className="col-10 col-sm-10 col-md-3 col-lg-3 col-xl-3">
                  <Form.Label className="party-size-label">
                    Seating Preference
                  </Form.Label>
                  <p className="seating-preference">
                    Seating is a subject to availability. Your Preference will
                    be considered.
                  </p>
                </div>
              </Form.Row>
              <Form.Row className="margin-top-section">
                {allSeatingArea.map((icon, index) => (
                  <div
                    className="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 mb-3"
                    key={index}
                  >
                    <IconBoxReusableComponent
                      classSection={
                        seating_preference === icon.title
                          ? "seating-Iconbox-reusable seating-Iconbox-reusable-active"
                          : "seating-Iconbox-reusable"
                      }
                      title={icon.title}
                      iconText={icon.title}
                      onClick={(e) => this.onButtonClick(e, icon.title)}
                    />
                  </div>
                ))}
              </Form.Row>
              <Form.Row className="margin-top-section">
                <div className="col-12 mb-3">
                  <Form.Label className="party-size-label">
                    Special Occasion
                  </Form.Label>
                </div>
                <div className="col-12 mb-3">
                  <TextAreaReusableComponent
                    controlId="occasion"
                    displayText={false}
                    labelText="Special Occasion"
                    labelTextClass="text-area-lable"
                    placeholder="eg. Wedding Anniversary"
                    rows="5"
                    onChange={this.onChange}
                    name="occasion"
                    value={editDiner.occasion}
                    inputClassName={classnames(
                      "input-text-area text-area-new",
                      {
                        invalid: errors.occasion,
                      }
                    )}
                    error={errors.occasion}
                  />
                </div>
              </Form.Row>
              <div
                className="row justify-content-end position-sticky "
                style={{ bottom: 0 }}
              >
                <div className="col-12 bottom-button d-flex justify-content-end mt-4">
                  <PopupActionButton
                    buttonText="Cancel"
                    buttonType="button"
                    buttonClass={
                      this.state.actionButton === true
                        ? "bigbuttongray"
                        : "bigbuttonred"
                    }
                    onClick={this.onCloseModal}
                  />
                  <div className="margin-seating-left">
                    <PopupActionButton
                      buttonText="Save"
                      buttonType={
                        this.state.actionButton === true ? "Submit" : "button"
                      }
                      buttonClass={
                        this.state.actionButton === true
                          ? "bigbuttonred"
                          : "bigbuttongray"
                      }
                    />
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

EditReservation.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  onboarding: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_dashboard_edit_action,
})(withRouter(EditReservation));
